import React, { FC } from 'react';

export interface Props {
  value: string | undefined;
  enabled: boolean;
  target: string | undefined;
  text: string;
  textColor: string | undefined;
}

const WebLinkField: FC<Props> = ({ value, enabled, target, text, textColor }: Props) => {
  return (
    <div>
      <a
        href={value}
        style={{ color: textColor }}
        className={`btn btn-link px-0 ${enabled ? '' : 'disabled'}`}
        target={target}
      >
        {text}
      </a>
    </div>
  );
};

export default WebLinkField;
